import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { addCategory } from '../../services/categoryService';

const AdminCategoryAdd = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Kategori ekleme işlemi için servis çağrısı
      await addCategory({
        name: formData.name.toUpperCase(), // Kategori ismini büyük harfe çeviriyoruz
        description: formData.description,
      });

      // Başarılı olursa kategoriler listesine yönlendirme
      navigate('/admin/categories');
    } catch (err) {
      setError('Kategori eklenirken bir hata oluştu.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ marginTop: '30px' }}>
      <Typography variant="h4" gutterBottom>
        Kategori Ekle
      </Typography>
      {error && (
        <Typography variant="body1" color="error" sx={{ marginBottom: '15px' }}>
          {error}
        </Typography>
      )}
      <Box component="form" onSubmit={handleSubmit}>
        <Typography style={{ color: 'red', marginBottom: '10px' }}>
          Kategori isminin tüm harfleri büyük eklenmelidir!
        </Typography>
        <TextField
          label="Kategori Adı"
          name="name"
          fullWidth
          margin="normal"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <TextField
          label="Açıklama"
          name="description"
          fullWidth
          margin="normal"
          multiline
          rows={4}
          value={formData.description}
          onChange={handleChange}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ marginTop: '15px' }}
          disabled={loading}
        >
          {loading ? 'Ekleniyor...' : 'Kategoriyi Ekle'}
        </Button>
      </Box>
    </Container>
  );
};

export default AdminCategoryAdd;
